import React from 'react'
import { browserHistory } from 'react-router'

import LeaseTenantView from '../../components/Lease/LeaseTenantView.jsx'

export default class LeaseTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    saveLeaseData(context){
    }

    render(){
        return (
            <div>
                <LeaseTenantView customAction={this.props.customAction} leaseID={this.props.leaseID} saveData={this.saveLeaseData.bind(this)}/>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/LeaseTenant/LeaseTenant.jsx